import React from 'react';
import ClearIcon from '@mui/icons-material/Clear';
import JunoButton from '../common/JunoButton';
import PropTypes from 'prop-types';
function ActiveFilters({ filters, onClear, onRemoveFilter, getStatus, displayText }) {
    const getActiveFilters = () => {
        const active = [];

        if (filters.from || filters.to) {
            active.push({
                key: 'date',
                label: `DATE: ${displayText}`,
                removeKey: 'from', // This will clear both from and to in the parent
            });
        }

        if (filters.currencyType && filters.currencyType.length > 0) {
            active.push({
                key: 'currencyType',
                label: `CURRENCY TYPE: ${filters.currencyType[0]}`,
                removeKey: 'currencyType',
            });
        }

        if (filters.currency && filters.currency.length > 0) {
            const currencyValues = filters.currency.map(c => 
                typeof c === 'object' ? c.currencyShortName : c
            );
            
            active.push({
                key: 'currency',
                label: `CURRENCY: ${currencyValues.join(', ')}`,
                removeKey: 'currency',
            });
        }

        if (filters.status && filters.status.length > 0) {
            if (filters.statusDisplay && filters.statusDisplay.length > 0) {
                active.push({
                    key: 'status',
                    label: `STATUS: ${filters.statusDisplay.join(', ')}`,
                    removeKey: 'status',
                });
            } else {
                const statusValues = filters.status.map(statusCode => 
                    getStatus ? getStatus(statusCode) : statusCode
                ).filter(s => s && s !== 'N/A');
                
                if (statusValues.length > 0) {
                    active.push({
                        key: 'status',
                        label: `STATUS: ${statusValues.join(', ')}`,
                        removeKey: 'status',
                    });
                }
            }
        }

        if (filters.type && filters.type.length > 0) {
            active.push({
                key: 'type',
                label: `TRANSACTION TYPE: ${filters.type.join(', ')}`,
                removeKey: 'type',
            });
        }

        return active;
    };

    const activeFilters = getActiveFilters();

    if (activeFilters.length === 0) return null;

    return (
        <div className="flex flex-col lg:flex-row items-start lg:items-center gap-2 mb-2 lg:px-6">
            {activeFilters.map(filter => (
                <div
                    key={filter.key}
                    className="inline-flex items-center !bg-secondary !text-primary px-3 py-1 rounded-md text-sm font-semibold uppercase">
                    <span>{filter.label}</span>
                    <JunoButton
                        type="custom"
                        onClick={() => onRemoveFilter(filter.removeKey)}
                        className="ml-2 !w-auto !h-4 !px-0 !py-0 !gap-0 text-filterPannel-icon hover:text-filterPannel-icon-hover transition-colors">
                        <ClearIcon fontSize="small" className="w-2 h-2 text-current" />
                    </JunoButton>
                </div>
            ))}
            <JunoButton
                type="custom"
                onClick={onClear}
                className="!text-widget max-w-[112px] no-wrap text-sm hover:underline ml-2 transition-colors font-semibold">
                RESET ALL ({activeFilters.length})
            </JunoButton>
        </div>
    );
}

ActiveFilters.propTypes = {
    filters: PropTypes.shape({
        from: PropTypes.string,
        to: PropTypes.string,
        currencyType: PropTypes.arrayOf(PropTypes.string),
        currency: PropTypes.arrayOf(PropTypes.string),
        status: PropTypes.arrayOf(PropTypes.string),
        type: PropTypes.arrayOf(PropTypes.string),
    }).isRequired,
    onClear: PropTypes.func.isRequired,
    onRemoveFilter: PropTypes.func.isRequired,
    getStatus: PropTypes.func,
    displayText: PropTypes.string.isRequired,
};

export default ActiveFilters;
